// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__FGkeh","select":"Header_select__1br2u","clinic":"Header_clinic__2fmRJ"};